module.exports = {
    totalWard: 15,
};
